<template>
    <div class="search-item">
        <div class="item">
            <button class="button" data-type="open-search" v-on:click="showSearch()" aria-label="Cerca">
                <span class="icon fastic-search"></span>
            </button>
        </div>
        <div class="app-search" v-bind:data-show="isSearchVisible">
            <div class="search">
                <div class="app-width">
                    <button class="close" v-on:click="showSearch()" aria-label="Chiudi ricerca"><span class="icon fastic-close"></span></button>
                    <div class="title">{{ localizer.get("App.Common.SearchInTechnicalCeramic") }}</div>
                    <div class="form" data-type="search">
                        <input v-model="searchText" class="textbox textbox-search" :placeholder="localizer.get('App.Common.Search_Placeholder')" type="text" :aria-label="localizer.get('App.Common.Search_Placeholder')">
                        <span v-on:click="showAll()" aria-label="Mostra tutti i risultati"><span class="fastic-search icon"></span></span>
                    </div>
                </div>
            </div>
            <div class="suggestion" v-if="suggestions.length > 0">
                <div class="app-width">
                    <div class="products">
                        <div class="list">
                            <a :href="suggestion.linkUrl" class="item" v-for="suggestion in suggestions" v-on:click="sendEvent()">
                                <div class="offertag">{{ localizer.get("App.Catalogue.Offer") }}</div>
                                <div class="image"><img :src="suggestion.imageUrl" width="303" height="303" loading="lazy" /></div>
                                <div class="desc">{{ suggestion.title }}</div>
                                <div class="price">
                                    <span class="from">{{ localizer.get("App.Common.From") }}</span>
                                    <span class="unit">{{ localizer.get("Catalogue.Common.Euro") }}</span><span class="val">{{ suggestion.price }}</span>
                                </div>
                                <div class="calltoaction" data-color="greyl"><span class="button">{{ localizer.get("Catalogue.Common.FindOutMore") }}</span></div>
                            </a>
                        </div>
                    </div>
                    <div class="count">
                        <div class="calltoaction">
                            <button @click="showAll()" class="button">{{ localizer.get("App.Common.Search_ShowAll") }}</button>
                        </div>
                    </div>
                </div>
            </div>
            <div class="suggestion no-result" v-else-if="suggestions.length == 0 && searchText != '' && searchText.length > 2">
                <div class="app-width">
                    <div class="title mrg" data-mrgb="15">{{ localizer.get("App.Common.Search_NotFound_Title") }}</div>
                    <div class="abstract">{{ localizer.get("App.Common.Search_NotFound_Abstract") }}</div>
                </div>
            </div>
        </div>
    </div>
</template>

<script setup lang="ts">
import { ref, watch } from "vue";
import GTagHelper from "@Scripts/Infrastructure/GTagHelper";
import Localizer from "@Scripts/Common/Localizer";
import Axios from "axios";

const localizer = Localizer;
const routes = (window as any).App.routes;

const isSearchVisible = ref(false);
const searchText = ref("");
const minTextLength = ref(3);
const suggestionCount = ref(0);
const debounceTimeOut = ref<any>(null);
const suggestionIndex = ref(-1);
const isSuggestionNotFound = ref(false);
const isLoading = ref(false);
const suggestions = ref<any[]>([]);

watch(searchText, (newText: string) => {
    debounceGetSuggestions(newText, 500);
});

function showSearch() {
    isSearchVisible.value = !isSearchVisible.value;
}

function showAll() {
    GTagHelper.sendEvent("view_search_results", "header_search", "all_detail");

    window.location.href = routes.Search_List + "?searchtext=" + searchText.value;
}

function sendEvent() {
    GTagHelper.sendEvent("view_search_results", "header_search", "product");
}

function debounceGetSuggestions(searchtext: any, delay: number) {
    clearTimeout(debounceTimeOut.value);

    debounceTimeOut.value = setTimeout(async function () {
        if (searchtext != null && searchtext.length >= 3) {
            await getSuggestions(searchtext);
        } else if (searchtext === null || searchtext.length === 0) {
            clearSearch();
        }
    }, delay);
}

function checkMinTextLength(text: string): boolean {
    return text && text.length >= minTextLength.value;
}

async function getSuggestions(searchtext: string) {
    isLoading.value = true;

    suggestions.value = [];

    try {
        const response = (await Axios.post(routes.Search_GetSuggestions, { searchtext: searchtext })).data;

        suggestions.value = response;

        isSuggestionNotFound.value = suggestions.value.length === 0;
    } catch (error: any) {
        if (error.response && error.response.status === 400) {
            suggestions.value = [];
        }
    }

    isLoading.value = false;
}

function resetSuggestionValues() {
    suggestionIndex.value = -1;
    suggestions.value = [];
}

function suggestionMoveDown() {
    if (suggestions.value.length !== 0 && suggestionIndex.value < suggestions.value.length - 1) {
        suggestionIndex.value++;
    }
}

function suggestionMoveUp() {
    if (suggestions.value.length !== 0 && suggestionIndex.value > 0) {
        suggestionIndex.value--;
    }
}

function setSuggestion() {
    if (suggestionIndex.value !== -1) {
        const suggestion = suggestions.value[suggestionIndex.value];
        window.location.href = suggestion.linkUrl;
    }
}

function clearSearch() {
    searchText.value = "";
    suggestions.value = [];
    isSuggestionNotFound.value = false;
}

function searchList() {
    if (searchText.value?.length > 2) {
        window.location.href = `${routes.Support_SearchList}?searchtext=${searchText.value}`;
    }
}
</script>